const Unauthorized: React.FC = () => (
  <div className="flex flex-col align-items-center py-5 my-5 min-h-screen">
    <h3 className="font-semibold text-gray-500 pt-4 pr-4">Access Denied</h3>
  </div>
);

export default Unauthorized;
